import * as Yup from "yup";

export default Yup.object().shape({
    linkedin: Yup.string(),
    facebook: Yup.string(),
    instagram: Yup.string(),
    website: Yup.string(),
});